import { useSyncExternalStore } from "react";
import { getAuthState, subscribeAuthState } from "../auth/authStore";

export function useAuthState() {
  return useSyncExternalStore(subscribeAuthState, getAuthState, getAuthState);
}
